import { v4 as uuidv4 } from 'uuid';

export const uuid = uuidv4;

export const localUuid = () => {
    return `local-${uuidv4()}`;
}

export const isLocalUuid = (uuid: string) => {
    return uuid.startsWith('local-');
}